<template>
<!-- 面包屑导航 -->
  <div class="breadcrumb clearfix">
    <div class="left fl">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item,index) in breadlist" :key="index">{{item.name}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="fr">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadlist: [
          {name:'首页',path:'/'}
      ]
    };
  },
  created() {
    this.getBread();
  },
  methods: {
    getBread() {
      var list = this.breadlist;
      this.$route.matched.forEach((item, index) => {
          if(item.meta.breadcrumb){
            var obj = {
              name:item.meta.breadcrumb,
              // path:item.path.substring(1)
          }
          list.push(obj)
          }
      });
      this.breadlist = list;
    }
  },
  watch: {
    $route() {
      this.getBread();
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  height: 60px;
  line-height: 60px;
  padding: 0 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/breadcrumb/index.vue